<template>
  <Shell :label="label" :tooltip="tooltip">
    <template v-slot:comp>
      <!-- image using the computed value as a url -->
      <img :src="value" :alt="label" class="w-full h-auto max-h-24 object-contain" v-if="isValueALink"/>
      <!-- if the value is not a link, display a placeholder or message -->
      <div v-else class="w-full h-24 flex items-center justify-center bg-gray-200 text-gray-500">
        {{ value || 'No image available' }}
      </div>
    </template>
  </Shell>
</template>
<script setup="props">
import { defineProps, computed } from "vue";
import { useRouter } from "vue-router";

import Shell from "./Shell.vue";
const router = useRouter();
// define the component props
const props = defineProps({
  link: String,
  label: String,
  value: [String, Number],
  grow: Boolean,
  name: String,
  customIcon: String,
  tooltip: String,
  richtext: Boolean,
});

const goto = (address) => {
  router.push(address);
};

defineEmits(["customIconClicked"]);

const isValueALink = computed(() => {
  return props.value && props.value.startsWith("http");
})

</script>
